import React from 'react'
import styles from './styles.css'
import {withRouter} from 'react-router'
import Loading from 'orionsoft-parts/lib/components/Loading'
import Paginated from 'meteor-paginated-graphql-react'
import MdGroup from 'react-icons/lib/md/group'
import moment from 'moment'
import MdDelete from 'react-icons/lib/md/delete'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

@withMutation(gql`
  mutation deleteProduct($productId: ID) {
    deleteProduct(productId: $productId) {
      success
    }
  }
`)
@withRouter
@withMessage
export default class Main extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    deleteProduct: PropTypes.func
  }

  getFields() {
    return [
      {title: '', name: '_id', render: () => <MdGroup />},
      {
        title: 'Código',
        name: 'productCode'
      },
      {
        title: 'Descripción',
        name: 'description'
      },
      {
        title: 'Fecha de ingreso',
        name: 'date',
        render: ({date}) => moment(date).format('DD/MM/YYYY HH:mm')
      },
      {
        title: '',
        name: '',
        render: item => this.renderDelete(item)
      }
    ]
  }

  @autobind
  async delete(item) {
    const result = window.confirm(
      `Estas eliminando el producto: {código: ${item.productCode}, descripción: ${
        item.description
      }}. ¿Deseas continuar?`
    )
    if (!result) return
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.deleteProduct({productId: item._id})
      this.props.showMessage('Producto eliminado satisfactoriamente!')
      this.refs.paginated.reload()
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderDelete(item) {
    return (
      <div className={styles.delete}>
        <MdDelete onClick={() => this.delete(item)} />
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className={styles.title}>
              <h3 className={styles.title}>Productos Security Sat</h3>
            </div>
          </div>
          <Paginated
            loadingComponent={Loading}
            queryName="ssProducts"
            fields={this.getFields()}
            ref="paginated"
            params="$filter: String"
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Custom/AllProducts/index.js